import { Box, styled } from '@mui/material';

import { doNotForwardTheseProps } from '@/styles/utils';

import { MobileOnly } from '../Layout/Responsive';

export const Container = styled(MobileOnly, {
  shouldForwardProp: doNotForwardTheseProps('isOnDark', 'bgColor'),
})<{ isOnDark?: boolean; bgColor?: string }>(
  ({ theme, isOnDark, bgColor }) => ({
    color: isOnDark ? theme.palette.common.white : theme.palette.text.primary,
    backgroundColor: bgColor || 'transparent',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    left: 0,
    top: 0,
    height: theme.layout.headerHeight.xs,
    width: '100%',
    zIndex: theme.zIndex.appBar,

    '.MuiGrid-container': {
      height: '100%',
      alignItems: 'center',
    },
  }),
);

export const Slot = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));
